/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import fetchHelper from "../services/fetchHelper";

const BASE_URL = "/patientmanagement/rest/reportstatements";

export const addItem = async ({ item, userInfo }) => {
  return await fetch(BASE_URL, {
    method: "POST",
    headers: fetchHelper.getSecurityHeader(),
    body: JSON.stringify({
      interrogation: { id: (userInfo || {}).id },
      cstId: item.id,
    }),
  });
};

export const updateItem = async ({ message, reportStateMentId }) => {
  return await fetch([BASE_URL, reportStateMentId].join("/"), {
    method: "PUT",
    headers: fetchHelper.getSecurityHeader(),
    body: JSON.stringify({
      note: message,
      id: reportStateMentId,
    }),
  });
};

export const removeItem = async ({ item, userInfo }) => {
  const url = `${BASE_URL}/removeStatement?`;
  return await fetch(url + new URLSearchParams({ irId: (userInfo || {}).id, cstId: item.id }), {
    method: "PUT",
    headers: fetchHelper.getSecurityHeader(),
    body: JSON.stringify({}),
  });
};

/**
 * Normalize checkbox id to match the data from the JSON file and how the backend expects it
 * @example normalizeCheckboxId("20112-P") // "20112p"
 * @param {string|number} id
 * @returns {string|number}
 */
export const normalizeCheckboxId = (id) => {
  if (typeof id === "string" && id.includes("-")) {
    const [left, right] = id.split("-");
    return `${left}${right.toLowerCase()}`;
  }

  return id;
};
